import React from "react"

import { OverlayHeader } from "shared/ui/overlay/OverlayHeader"
import { OverlayWrapper } from "shared/ui/overlay/OverlayWrapper"

import { ScrivitoPortalNewsList } from "widgets/portal-news-list/ScrivitoPortalNewsList"

import { PortalNewsOverlayModel } from "./PortalNewsOverlayConnector"

interface PortalNewsOverlayViewProps extends PortalNewsOverlayModel {}

export const PortalNewsOverlayView = React.memo(
  ({ listModel, page, onClose }: PortalNewsOverlayViewProps) => {
    return (
      <OverlayWrapper
        id="portal-news-overlay"
        className="portal-news-overlay"
        classNamePrefix="portal-news-overlay"
        headline={page?.get("title")}
        mobileFullscreen
        desktopFullscreen
      >
        <OverlayHeader.Container prefix="product-configuration-overlay">
          <OverlayHeader.CloseButton onClick={onClose} className="primary" />
          <OverlayHeader.Title>{page?.get("title")}</OverlayHeader.Title>
        </OverlayHeader.Container>
        <div className="overlay-scroll-container">
          <ScrivitoPortalNewsList {...listModel} />
        </div>
      </OverlayWrapper>
    )
  }
)
